import { initApp } from '@js/initApp';
import App from './App.vue';

/**
 *
 * @param containerSelector
 * @param data {{
    event: {},
    playerType: "",
    eventTagId: 123,
    features: {
      timeline: {
        enable: true,
        minimal: false,
      },
      player: {
        autoplay: true,
        time: false,
        liveBadge: true,
        logo: true, // bool or string representing the image URL
        seek: true,
        pause: true,
        stop: false,
        contentInfoEnabled: true,
      },
      sharing: true,
    }
  }} | null
 * @return {{mute(): void, unmute(): void}}
 */
const init = (data = null) => {
	return initApp('embed', App, null, data);
};

export { init };
